import React from 'react';

export default function ApprovedBubbles({fill = '#54D2C3'}) {
    return (
        <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M30.1992 0.302734C13.6289 0.302734 0.199219 13.7324 0.199219 30.3027C0.199219 46.873 13.6289 60.3027 30.1992 60.3027C46.7695 60.3027 60.1992 46.873 60.1992 30.3027C60.1992 13.7324 46.7695 0.302734 30.1992 0.302734ZM43.7695 25.123L28.7695 40.123C28.125 40.7676 27.293 41.084 26.4492 41.084C25.6055 41.084 24.7688 40.7654 24.1277 40.1245L16.6277 32.6245C15.3492 31.3424 15.3492 29.2623 16.6277 27.9803C17.9098 26.6983 19.9898 26.6983 21.2719 27.9803L26.4492 33.1621L39.1289 20.4824C40.4109 19.2004 42.491 19.2004 43.773 20.4824C45.0469 21.7598 45.0469 23.8457 43.7695 25.123Z"
                fill={fill}
            />
        </svg>
    );
}



// WEBPACK FOOTER //
// ./components/approved_bubbles/index.js